import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { dealApi, dealQueryKeys } from '@crm/entities/deal';
import { toastManager } from '@crm/entities/toast';
import { getApiErrorMessage } from '@crm/shared/api';

import type { TDeal, TSetDealTaskCompletedParams } from '@crm/entities/deal';

export const useSetDealTaskCompletedMutation = ({ dealId }: { dealId: TDeal['id'] }) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [...dealQueryKeys.detail(dealId), 'tasks', 'set-is-completed'],
        mutationFn: ({ payload, taskUid }: Omit<TSetDealTaskCompletedParams, 'dealId'>) =>
            dealApi.setDealTaskCompleted({ dealId, payload, taskUid }),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: dealQueryKeys.detail(dealId) });
        },
        onError: (error) => {
            toastManager.onError({
                title: getApiErrorMessage(
                    error,
                    t('crm.dealDetailsContent.tasksBlock.errors.complete')
                ),
            });
        },
    });
};
